import * as type from '../actions/types';

const initialState = {
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.PAY_BALANCE_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.PAY_BALANCE_SUCCESS: {
      return {
        ...state,
        pending: false,
        success: true,
      };
    }

    case type.PAY_BALANCE_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
        success: false,
      };
    }

    default: {
      return state;
    }
  }
};
